import { render, staticRenderFns } from "./DoanhThuBoschForm.vue?vue&type=template&id=632a6846&"
import script from "./DoanhThuBoschForm.vue?vue&type=script&lang=js&"
export * from "./DoanhThuBoschForm.vue?vue&type=script&lang=js&"
import style0 from "./DoanhThuBoschForm.vue?vue&type=style&index=0&id=632a6846&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports